"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiLink = getMuiLink;
function getMuiLink(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      underline: 'none'
    },
    styleOverrides: {
      root: {
        '&:active': {
          color: palette.primary.dark
        },
        '&:hover': {
          backgroundColor: palette.primary.light,
          borderRadius: '6px',
          color: palette.primary.dark
        }
      }
    },
    variants: [{
      props: {
        variant: 'link'
      },
      style: {
        '&:hover': {
          backgroundColor: 'transparent',
          borderRadius: 0,
          textDecorationLine: 'underline'
        },
        '.MuiSvgIcon-root': {
          color: palette.primary.dark,
          height: '18px',
          width: '18px'
        },
        alignItems: 'center',
        color: palette.primary.dark,
        display: 'flex',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px'
      }
    }, {
      props: {
        variant: 'linkDisabled'
      },
      style: {
        '&.MuiTypography-linkDisabled': {
          '&:hover': {
            color: palette.grey[300],
            cursor: 'default',
            textDecorationLine: 'none'
          },
          '.MuiSvgIcon-root': {
            color: palette.grey[300],
            height: '18px',
            width: '18px'
          },
          backgroundColor: 'transparent',
          borderRadius: 0
        },
        alignItems: 'center',
        color: palette.grey[300],
        display: 'flex',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px'
      }
    }, {
      props: {
        variant: 'smalltextregular'
      },
      style: {
        '&:hover': {
          backgroundColor: 'transparent',
          borderRadius: 0,
          textDecorationLine: 'underline'
        },
        '.MuiSvgIcon-root': {
          color: palette.primary.dark,
          height: '18px',
          width: '18px'
        },
        alignItems: 'center',
        color: palette.primary.dark,
        display: 'flex'
      }
    }, {
      props: {
        color: 'black'
      },
      style: {
        '&:hover': {
          '.MuiSvgIcon-root': {
            color: palette.primary.dark
          },
          backgroundColor: 'transparent',
          borderRadius: 0,
          color: palette.primary.dark,
          textDecorationLine: 'underline'
        },
        '.MuiSvgIcon-root': {
          color: palette.grey[600],
          height: '18px',
          width: '18px'
        },
        alignItems: 'center',
        color: palette.grey[800],
        display: 'flex',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px'
      }
    }]
  };
}